import { Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';

/**
 * Resolves the display text of a quantity unit (Mengeneinheit, pick list "MEH": kg, mt, qm, stk, ...).
 *
 * Used for the sales, stock and package units as well as for the factor titles of an input unit
 * (BO3_ARTICLESALESUNITS.TITLE1-3). The unit code is used as translation key below
 * `shared.quantity-units`, falling back to the raw code coming from the ERP.
 */
@Pipe({
  name: 'quantityUnitName',
})
export class QuantityUnitNamePipe implements PipeTransform {
  private static readonly TRANSLATION_PREFIX = 'shared.quantity-units';

  constructor(private transloco: TranslocoService) {}

  public transform(unit: string | undefined | null): string {
    if (!unit) {
      return '';
    }

    const translationKey = `${QuantityUnitNamePipe.TRANSLATION_PREFIX}.${unit.trim()}`;
    const translation: string = this.transloco.translate(translationKey);

    return translation && translation !== translationKey ? translation : unit;
  }
}
